export const data = {
  home: {
    en: {
      '一层': '1F',
      '二层': '2F',
      '三层': '3F',
      '四层': '4F',
      '五层': '5F',
      '六层': '6F',
      '七层': '7F',
      '八层': '8F',
      '九层': '9F',
      '观影美食': 'Food & Beverage',
      '立即购买': 'Buy Now',
      '荧幕': ' Screen',
      '我的': 'Me',
      '您确认要取消该订单吗?': 'Are you sure you want to cancel this order?',
      '点击切换不同票价，再次点击取消选择': 'Click to view different ticket rates.Click again to cancel',
      '福豆': 'FuDou',
      '停售': 'Sellout',
      'AX': 'AX',
      '复制': 'Copy',
      '复制成功': 'Successful',
      '复制失败': 'Failed',
      'BX': 'BX',
      '排': 'row',
      '座': 'seat',
      '请重新登录': 'Pls login again',
      '购买': 'Buy',
      '开场不足30分钟,已停止售票': 'Less than 30mins left before the opening. Ticketing is out of service',
      '影院服务': 'Cinema service',
      '交通信息': 'Traffic information',
      '当前影院暂无电影排片': 'No schedule found in this cinema',
      '如有疑问请联系': 'Pls ask for help if required',
      '可选': 'Optional',
      '已售': 'Sold',
      '情侣座': 'Love seat',
      '确认选座': 'Confirm',
      '热度': 'Popularity',
      '销量': 'Sales volume',
      '最多可选X个座位': 'Maximum X seats',
      '临近开场提醒': 'Opening prompt',
      '已开场提醒': 'Opening prompt',
      '临近开场提醒：您选购的场次将在': 'Opening prompt: your session will',
      '分钟内开场，临近开场场次出票时间较长且出票失败率高，建议选购下个场次': 'mins are left before opening. Ticketing of upcoming session needs more time and might be failed. Pls place an order after confirmation',
      '继续购票可能出票时间较长且出票失败率高，建议选购下个场次': 'Ticketing needs more time and might be failed if you continue to buy ticket. You are suggested to buy the next session.',
      '已开场提醒：您选购的场次': 'Opening prompt: your session',
      '您选择的是': 'Your choice is ',
      '加载影院信息异常': 'Cinema info. loading is abnormal',
      '热映': 'Showing',
      '影院': 'Cinema',
      '待映': 'To be released',
      '松开加载数据': 'Lift to upload data',
      '即将上映': 'Upcoming movies',
      '票房榜单': 'List of box office',
      '热映推荐': 'Movie recommendation',
      '当前城市暂无影院': 'No cinema found in this city',
      '参考价:暂无': 'RP: N/A',
      '近期场次': 'Latest session',
      '当前定位城市': 'Locate current city',
      '加载中': 'Loading',
      '电影订单': 'Movie order',
      '输入城市或者首字母': 'Input city or initial',
      '最近访问城市': 'Latest visited city',
      '热门城市': 'Popular city',
      '主演': 'Protagonist',
      '导演': 'Director',
      '预售': 'Presale',
      '购票': 'Buy',
      '影片信息加载中': 'Uploading film info.',
      '类型': 'Type',
      '片长': 'Length',
      '分钟': 'Mins',
      '离我最近': 'Shortest distance',
      '综合排序': 'Comprehensive ranking',
      '价格最低': 'Cheapest price',
      '全部': 'All',
      '待支付': 'To be paid',
      '已支付': 'Paid',
      '出票中': 'Issuing',
      '出票成功': 'Successful',
      '已取消': 'Cancelled',
      '订单取消出现错误': 'Order cancel goes wrong',
      '取消订单成功': 'Successful',
      '去逛逛': 'Go now',
      '您还没有订单哦~赶紧去购物吧！': 'You don\'t have orders~ Go shopping now!',
      '已经到底啦': 'End',
      '您确认要取消该订单吗': 'Are you sure you want to cancel this order?',
      '暂不取消': 'Undecided',
      '确定取消': 'Cancel',
      '起': 'Starting',
      '暂无影院排期': 'No movie schedule',
      '看看其他日期': 'View other dates',
      '座位旁边请不要留空': 'Pls don’t leave vacancy near seat',
      '请输入取票手机号': 'Pls input phone no. taking ticket',
      '取消': 'Cancel',
      '请先选座': 'Pls select seat firstly',
      '确定': 'Confirm',
      '请填写正确手机号': 'Pls properly input phone No.',
      '实名信息读取错误': 'Fail to read real-name info.',
      '返回后，您选中的座位将不再保留': 'Your selected seat will not be reserved after returning',
      '继续选座': 'Continue',
      '返回': 'Return',
      '我知道了': 'I got it',
      '知道了': 'Got it',
      '锁定座位失败，请重新选座': 'Fail to lock seat, pls reselect seat',
      '选座超时，请在10分钟内完成选座': 'Selection times out, pls select seat within 10 mins',
      '今天': 'Today',
      '明天': 'Tomorrow',
      '后天': 'After one day',
      '周一': 'Mon.',
      '周二': 'Tues.',
      '周三': 'Wed.',
      '周四': 'Thur.',
      '周五': 'Fri.',
      '周六': 'Sat.',
      '周日': 'Sun.',
      '请填写姓名': 'Pls fill in name',
      '身份证': 'ID Card',
      '护照': 'Passport',
      '台胞证': 'Mainland travel permit for Taiwan residents',
      '港澳台通行证': 'Exit-Entry permit for travelling to and from Hong Kong and Macao travel permit for Taiwan residents',
      '请选择证件类型': 'Pls select certificate type',
      '请填写证件号': 'Pls certificate number',
      '请填写正确的证件号码': 'Pls properly fill in certificate number',
      '请填写11位手机号': 'Pls input phone no. of 11 digits',
      '证件类型': 'Certificate type',
      '证件号码': 'Certificate number',
      '姓名': 'Name',
      '手机号': 'Phone number',
      '请输入证件号码': 'Pls input input certificate no.',
      '根据国家电影局疫情防控要求，购票需实名认证': 'According to the pandemic prevention and control rules of China Film Administration, the real-name ticket purchasing is required.',
      '实名认证': 'Real-name authentication',
      '请输入姓名': 'Pls input name',
      '请输入手机号': 'Pls input phone number ',
      '验证码发送成功': 'Send identifying code successfully',
      '请核实订单信息确认无误后下单': 'Pls place an order after verify order',
      '将在X分钟后开场': 'Opening after Xmins',
      '临近开场的场次出票时间较长且出票失败率高，请确认无误后下单': 'Ticketing of upcoming session needs more time and might be failed. Pls place an order after confirmation',
      '请填写验证码': 'Pls fill in identifying code',
      '确认订单': 'Confirm order',
      '重新发送': 'Send again ',
      '发送验证码': 'Send',
      '需支付': 'To be paid',
      '明细': 'Details',
      '提交订单': 'Submit order',
      '支付明细': 'Payment details',
      '票品详情': 'Ticket details',
      '您选择的是X的场次': 'You select X session',
      '再看看': 'Check more',
      '确认提交': 'Confirm',
      '影院介绍': 'Cinema profile',
      '填写取票手机号': 'Pls fill in phone number of ticket collection',
      '取票手机号': 'Phone number of ticket collection',
      '的场次': '  Of Session',
      '信息核实': 'Ticket details',
      '月': '/',
      '日': ' ',
      '将在': 'Will',
      '后开场': 'Opening',
      '当前城市暂无影片': 'No film in this city',
      '票价单位为': 'Unit of ticket rate is',
      '预计1~3分钟会出票完成': 'Ticket will be issued within 1~3mins',
      '刷新': 'Refresh',
      '申请退款': 'Apply for a refund',
      '退款成功': 'Successful',
      '退款失败': 'Failed',
      '退款中': 'Refunding',
      '支付超时': 'Time-out payment',
      '出票失败': 'Failed',
      '系统取消原因': 'Reason of system cancelation',
      '请在X内支付完成': 'Please pay within X ',
      '点卡[尾号x]支付': 'Paid by points card [tail no. X]',
      '退回点卡[尾号X]': 'Return points card [tail no. X]',
      '次卡[尾号x]支付': 'Paid by times card [tail no. X]',
      '退回次卡[尾号X]': 'Return times card [tail no. X]',
      '次卡[尾号X]': 'Times card [tail no. X]',
      '点卡[尾号X]': 'Points card [tail no. X]',
      'X次': 'X times',
      '退款明细': 'Refund details',
      '退回X': 'Return X',
      '订单号': 'Order No.',
      '创建时间': 'Creation time',
      '立即支付': 'Pay now',
      '取消支付': 'Cancel payment',
      '取票凭证': 'Ticket collection voucher',
      '取票码': 'Ticket collection code',
      '内含X张': 'Including X piece(s)',
      '请凭取票码至影院取票': 'Pls take ticket with ticket collection code',
      '请凭二维码或取票码至影院取票': 'Pls take ticket with QR code or ticket collection code at the cinema',
      '继续支付': 'Continue to pay',
      '最新退款时间': 'Latest refund time',
      '付款时间': 'Payment time',
      '合计': 'Total',
      '订单详情': 'Order details',
      '开场，临近开场场次出票时间较长且出票失败率高，建议选购下个场次': 'opening. Ticketing of upcoming session needs more time and might be failed. Pls place an order after confirmation',
      'X分钟内': 'Within Xmins',
      '返回首页': 'Back homepage',
      '已开场': 'Opened',
      '不支持退换': 'Not available for return',
      '未取票未开场支持退票，不支持改签': 'If you don\'t take ticket and film doesn\'t start, you can return ticket but can\'t change ticket.',
      '支付结果': 'Result',
      '填写手机号': 'Pls fill in phone number',
      '填写验证码': 'Pls fill in identifying code',
      '的场次，请确认无误后下单': 'X session, pls place an order after confirmation',
      '票品一经售出 不支持退款': 'Ticket is nonrefundable once it is sold.',
      '查看订单': 'View order',
      '支付成功': 'Successful',
      '热门': 'Popular',
      '尊享礼包': 'View order',
      '花礼网': 'Hualiwang',
      '小米有品': 'MI selection',
      '热度优先': 'Popularity first',
      '企业团险': 'Enterprise insurance',
      '美团酒店': 'Meituan Hotel',
      '享道出行': 'SAIC Mobility',
      '获取定位失败': 'Fail to obtain location',
      '定位中': 'Locating',
      '地址解析失败': 'Fail to parse address',
      '初始化成功': 'Successful initialization',
      '解析地址发生异常': 'Address resolution is abnormal',
      '商城首页': 'Mall',
      '个人中心': 'Me',
      '购物车': 'Cart',
      '优选生活': 'Preferred life',
      '图书': 'Books',
      '生日汇': 'Birthday',
      '京东优选': 'JD preference',
      '健康生活': 'Healthy life',
      '东福超市': 'DF market',
      '旅游玩乐': 'Tourism & entertainment',
      '生日礼遇': 'Birthday gift',
      '热门演出': 'Popular performance',
      '热映观影': 'Hot film',
      '节日礼包': 'Festival gift bag',
      '电影': 'film',
      '演出话剧': 'Drama',
      '企业活动': 'Business activity',
      '保险': 'Insurance',
      '东方福利网': 'DF',
      '热': 'hot',
      '抱歉~没有找到相关门店哦': 'Sorry~no relevant shop found',
      '浏览足迹': 'Browsing history',
      '商品': 'Products',
      '抱歉~暂无商品': 'Sorry~no product',
      '您可以切换城市或者筛选条件再试试': 'You can try again by changing city or screening conditions',
      '取消订单': 'Cancel',
      '剩余': 'Left XX',
      '共X张': 'X in total',
      '散场': 'Ends',
      '努力加载中': 'Loading',
      '小时': ':',
      '分': 'min',
      '秒': 'sec',
      '切换城市': 'Change city',
      '验证码不正确，请重新输入': 'Incorrect verification code, please enter again',
      '该手机号已被绑定': 'This phone no. has been bound',
      '支持退票': 'Return available',
      '不支持退票': 'Return unavailable',
      '超时不可退': 'Time-out order is irreversible',
      '不支持改签': 'Change unavailable',
      '退票须知': 'Return notice',
      '退票详情': 'Return details',
      '特别提醒': 'Special prompt',
      '仅限整单退票，不支持分座位退票': 'Return is only for order. Individual seat can’t be returned',
      '若支付金额小于退票手续费，不可退票': 'The return is unavailable if payment amount is less than return service charge',
      '退票规则': 'Return rules',
      '东福规则': 'DF rules',
      '个别特殊场次根据影院要求可能不支持退票。具体以下单页面说明为准。': ' Certain special sessions can’t be returned according to cinema’s requirements. Pls be subject to the order instructions. ',
      '电影开场前一定时间内且用户未取票的情况下可支持退票，退票将可能产生额外服务费，具体退票规则及收费标准以下单页面说明为准。原订单实际支付金额扣除退票服务费后，剩余金额将在退票成功后7个工作日内原路退回。': 'You can return ticket if you don’t take ticket within a certain time before opening. Return might incur additional service charge. Return rules and fees shall be subject to the order instructions. The remaining money that the actual payment amount deducts service charge will be refunded within seven workdays after return. ',
      '目前仅支持整笔订单退票，不支持单个座位退票。': 'Return is only for order. Individual seat can’t be returned.',
      '如发现作弊行为，东方福利网有权取消您的退票资格。': 'DF is entitled to canceling your return in case of cheating.',
      '退票流程': 'Return procedures',
      '在“我的-我的订单”中找到要退的电影票订单': 'Find the cinema ticket to be returned via “me-my order”',
      '进入电影票详情，点击底部的“申请退票”按钮': 'Enter cinema ticket details, and click “return application” at the bottom',
      '确认退款金额，点击“提交”退票申请按钮': 'Confirm refund amount, click “submit” to apply for return',
      '提交成功后，可在电影订单详情页查看退票进度': 'You can view return schedule via film order',
      '申请失败': 'Application failed',
      '订单金额小于退票手续费，不可退票': 'You can’t return cinema ticket if the order amount is less than return service charge',
      '失败原因': 'Reason for failure',
      '本月退票次数已用完，符合退票规则请联系在线客服咨询退票事宜': 'You run out of the number of return this month. Pls learn return from online customer service if you qualify for return rules',
      '订单金额': 'Order amount',
      '退票手续费': 'Return service charge',
      '退款金额': 'Refund amount',
      '预计3个工作日内原路返回': 'Refund is estimated to be received within three workdays',
      '预计1-7个工作日，退款金额将原路退回到您的支付账户': 'Amount is expected to be refunded within 1-7 workdays',
      '本次退款原因（必填）': 'This refund reason (required)',
      '请放心选择，不影响退款申请哦': 'Pls choose securely. Your refund application won’t be influenced',
      '选好了': 'I have chosen',
      '请选择退款原因': 'Pls select refund reason',
      '提交': 'Submit',
      '提交申请后不可撤销哦': 'Irrevocable after submitting application',
      '支付手续费并确认退票': 'Pay service charge and confirm return',
      '次卡兑换的退票服务费需要单独支付': 'If you use times card to exchange order, you need to independently pay service charge for refund',
      '正在退订X张电影票': 'Returning X cinema ticket',
      '确认退票': 'Confirm return',
      '我知道了（XS后自动跳转）': 'I got it (automatically skip after XS)',
      '申请退款结果': 'Refund application results',
      '申请退款中': 'Applying for refund',
      '实退': 'Actual refund',
      '查看申请退款详情': 'View refund application details',
      '申请退款失败': 'Fail to apply for refund',
      '支付手续费原路退回您的付款账户': 'The service charge paid will be refunded to your account',
      '买错时间/场次': 'Get time/session wrong',
      '买错影片': 'Get film wrong',
      '买错影院': 'Get cinema wrong',
      '行程计划有变，没时间看了': 'Have no time to see a movie as the schedule is changed',
      '影院原因（放映故障、场次被取消）': 'Due to cinema (projection failure and session cancelled)',
      '买贵了（买后降价）': 'Expensive mistake (lower price after buying)',
      '优惠未使用': 'Unused discount',
      '疫情/自然灾害等': 'Pandemic/natural disasters, etc.',
      '其他': 'Others',
      '申请退票': 'Apply for refund',
      '退票服务费': 'Return service charge',
      '退票原因': 'Refund reason',
      '退款原因': 'Refund reason',
      '去支付 X福豆 并确认退票': 'Pay service charge XFuDou and confirm return',
      '查看退款详情': 'View refund application details',
      '暂不支持改签服务': 'The change service is not supported for the time being.',
      '若支付金额小于退票服务费，不可退票': 'If the amount paid is less than the refund service fee, the ticket is not refundable.',
      '每人每月退票次数有限': 'The number of returning ticket by each person is limited per month.',
      '退票说明': 'Return details',
      '影院规则': 'Return rules',
      '（必填）': '(required)',
      '重新选座': 'Reselect seat',
      '没有更多了': 'No more',
      '抢折扣': 'Discount',
      '抢票': 'Buy Now',
      '买普通票': 'ordinary ticket',
      '购票说明': 'Note',
      '去抢折扣票': 'Discounted Ticket',
      '折': 'off',
      // '折扣票': 'The discounted ticket is ',
      // '票价优惠': 'preferential',
      // '，下单支付成功后一般出票时间预计在': ' and will be issued in ',
      // '30-60分钟': '30-60 minutes',
      // '。若未成功出票，退款会按原路返回。折扣票订单下单后，订单': ' once you place an order. If the ticket is not issued, the refund will be returned by the same route. The order of discounted ticket is ',
      // '不支持退票、改签。': 'nonrefundable and irreversible.',
      '折扣票': '-',
      '票价优惠': '-',
      '，当前抢票人数较多，请在支付完成后耐心等待出票结果。若未成功出票，退款会按原路返回。折扣票订单下单后，': 'Please wait patiently if you successfully pay the discounted ticket at rush hour. If the ticket is not issued, the refund will be returned by the same route. ',
      '不支持退票、改签。': 'The order of discounted ticket is nonrefundable and irreversible.',

      '时间': 'Session',
      '座位': 'Seats',
      '温馨提示：': 'Warm prompt: ',
      '本订单为折扣票，': 'this order is discounted ticket,',
      '不支持退票、改签、更换座位': 'which is nonrefundable, irreversible and unalternative',
      '。请核实订单信息及折扣票规则，确认无误后下单': '.  Please verify the order and discount rules and place an order after confirmation.',
      '请确认购票信息': 'Ticket Details',
      '当前场次已过抢折扣时间，请重新购票。': 'The current special offer is expired. Please buy ticket again.',
      // '预计30-60分钟出票，请耐心等待': 'Ticket will be issued in 30-60minutes. Please wait patiently.'
      '抢票高峰，请耐心等待出票。': 'Please wait patiently if you buy the discounted ticket at rush hour.',
      '去支付': 'Go to pay',
      '已有待支付订单，请先支付': 'Please pay the order first'
    },
    cn: {
      '一层': '一层',
      '二层': '二层',
      '三层': '三层',
      '四层': '四层',
      '五层': '五层',
      '六层': '六层',
      '七层': '七层',
      '八层': '八层',
      '九层': '九层',
      '观影美食': '观影美食',
      '立即购买': '立即购买',
      '当前场次已过抢折扣时间，请重新购票。': '当前场次已过抢折扣时间，请重新购票。',
      // '预计30-60分钟出票，请耐心等待': '预计30-60分钟出票，请耐心等待',
      '请确认购票信息': '请确认购票信息',
      '时间': '时间',
      '座位': '座位',
      '温馨提示：': '温馨提示：',
      '本订单为折扣票，': '本订单为折扣票，',
      '不支持退票、改签、更换座位': '不支持退票、改签、更换座位',
      '。请核实订单信息及折扣票规则，确认无误后下单': '。请核实订单信息及折扣票规则，确认无误后下单',
      '抢折扣': '抢折扣',
      '去抢折扣票': '去抢折扣票',
      '折': '折',
      '抢票': '抢票',
      '买普通票': '买普通票',
      '购票说明': '购票说明',
      // '折扣票': '折扣票',
      // '票价优惠': '票价优惠',
      // '，下单支付成功后一般出票时间预计在': '，下单支付成功后一般出票时间预计在',
      // '30-60分钟': '30-60分钟',
      // '。若未成功出票，退款会按原路返回。折扣票订单下单后，订单': '。若未成功出票，退款会按原路返回。折扣票订单下单后，订单',
      // '不支持退票、改签': '不支持退票、改签。',
      '荧幕': ' 荧幕',
      '小时': '小时',
      '分': '分',
      'X排X座': 'X排X座',
      '秒': '秒',
      '临近开场提醒': '临近开场提醒',
      '已开场提醒': '已开场提醒',
      '努力加载中': '努力加载中',
      '散场': '散场',
      '剩余': '剩余 XX',
      '共X张': '共X张',
      '取消订单': '取消订单',
      '申请退款': '申请退款',
      '退款成功': '退款成功',
      '您可以切换城市或者筛选条件再试试': '您可以切换城市或者筛选条件再试试',
      '浏览足迹': '浏览足迹',
      '商品': '商品',
      '抱歉~没有找到相关门店哦': '抱歉~没有找到相关门店哦',
      '热门城市': '热门城市',
      '热': '热',
      '东方福利网': '东方福利网',
      '保险': '保险',
      '优选生活': '优选生活',
      '健康生活': '健康生活',
      '图书': '图书',
      '东福超市': '东福超市',
      '旅游玩乐': '旅游玩乐',
      '生日礼遇': '生日礼遇',
      '热门演出': '热门演出',
      '京东优选': '京东优选',
      '热映观影': '热映观影',
      '商城首页': '商城首页',
      '个人中心': '我的',
      '节日礼包': '节日礼包',
      '电影': '电影',
      '生日汇': '生日汇',
      '演出话剧': '演出话剧',
      '企业活动': '企业活动',
      '没有更多啦': '没有更多啦',

      '购物车': '购物车',
      '获取定位失败': '获取定位失败',
      '定位中': '定位中',
      '地址解析失败': '地址解析失败',
      '初始化成功': '初始化成功',
      '解析地址发生异常': '解析地址发生异常',
      '支付成功': '支付成功',
      '查看订单': '查看订单',
      '票品一经售出 不支持退款': '票品一经售出 不支持退款',
      '的场次，请确认无误后下单': '的场次，请确认无误后下单',
      '填写手机号': '填写手机号',
      '填写验证码': '填写验证码',
      '支付结果': '支付结果',
      '点卡[尾号X]': '点卡[尾号X]',
      '次卡[尾号X]': '次卡[尾号X]',
      '已开场': '已开场',
      'X分钟内': 'X分钟内',
      '开场，临近开场场次出票时间较长且出票失败率高，建议选购下个场次': '开场，临近开场场次出票时间较长且出票失败率高，建议选购下个场次',
      '合计': '合计',
      '订单详情': '订单详情',
      '立即支付': '立即支付',
      '内含X张': '内含X张',
      '请凭取票码至影院取票': '请凭取票码至影院取票',
      '请凭二维码或取票码至影院取票': '请凭二维码或取票码至影院取票',
      '取票凭证': '取票凭证',
      '取票码': '取票码',
      '继续支付': '继续支付',
      '取消支付': '取消支付',
      '创建时间': '创建时间',
      '票价单位为': '票价单位为',
      '订单号': '订单号',
      '退款明细': '退款明细',
      '退回X': '退回X',
      'X次': 'X次',
      '退回点卡[尾号X]': '退回点卡[尾号X]',
      '点卡[尾号X]支付': '点卡[尾号X]支付',
      '次卡[尾号X]支付': '次卡[尾号X]支付',
      '退回次卡[尾号X]': '退回次卡[尾号X]',
      '请在X分X秒内支付完成': '请在X分X秒内支付完成',
      '系统取消原因': '系统取消原因',
      '出票失败': '出票失败',
      '支付超时': '支付超时',
      '退款中': '退款中',
      '刷新': '刷新',
      '预计1~3分钟会出票完成': '预计1~3分钟会出票完成',
      '福豆': '福豆',
      '加载影院信息异常': '加载影院信息异常',
      '月': '月',
      '当前城市暂无影片': '当前城市暂无影片',
      '将在': '将在',
      '日': '日',
      '的场次': '的场次',
      '信息核实': '信息核实',
      '填写取票手机号': '填写取票手机号',
      '您选择的是': '您选择的是',
      '取票手机号': '取票手机号',
      '继续购票可能出票时间较长且出票失败率高，建议选购下个场次': '继续购票可能出票时间较长且出票失败率高，建议选购下个场次',
      '已开场提醒：您选购的场次': '已开场提醒：您选购的场次',
      '临近开场提醒：您选购的场次将在': '临近开场提醒：您选购的场次将在',
      '分钟内开场，临近开场场次出票时间较长且出票失败率高，建议选购下个场次': '分钟内开场，临近开场场次出票时间较长且出票失败率高，建议选购下个场次',
      '最多可选X个座位': '最多可选X个座位',
      '可选': '可选',
      '确认选座': '确认选座',
      '情侣座': '情侣座',
      '已售': '已售',
      '停售': '停售',
      '购买': '购买',
      '分钟': '分钟',
      '开场不足30分钟,已停止售票': '开场不足30分钟,已停止售票',
      '影院服务': '影院服务',
      '交通信息': '交通信息',
      '影院介绍': '影院介绍',
      '当前影院暂无电影排片': '当前影院暂无电影排片',
      '如有疑问请联系': '如有疑问请联系',

      '热映': '热映',
      '影院': '影院',
      '待映': '待映',
      '松开加载数据': '松开加载数据',
      '即将上映': '即将上映',
      '票房榜单': '票房榜单',
      '热映推荐': '热映推荐',
      '当前城市暂无影院': '当前城市暂无影院',
      '参考价:暂无': '参考价:暂无',
      '近期场次': '近期场次',
      '当前定位城市': '当前定位城市',
      '加载中': '加载中',
      '输入城市或者首字母': '输入城市或者首字母',
      '最近访问城市': '最近访问城市',
      '热门': '热门',
      '主演': '主演',
      '导演': '导演',
      '预售': '预售',
      '购票': '购票',
      '影片信息加载中': '影片信息加载中',
      '类型': '类型',
      '片长': '片长',
      '离我最近': '离我最近',
      '综合排序': '综合排序',
      '价格最低': '价格最低',
      '全部': '全部',
      '待支付': '待支付',
      '已支付': '已支付',
      '出票中': '出票中',
      '出票成功': '出票成功',
      '已取消': '已取消',
      '订单取消出现错误': '订单取消出现错误',
      '取消订单成功': '取消订单成功',
      '您还没有订单哦~感觉去购物吧！': '您还没有订单哦~感觉去购物吧！',
      '去逛逛': '去逛逛',
      '已经到底啦': '已经到底啦',
      '您确认要取消该订单吗': '您确认要取消该订单吗',
      '暂不取消': '暂不取消',
      '确定取消': '确定取消',
      '起': '起',
      '暂无影院排期': '暂无影院排期',
      '看看其他日期': '看看其他日期',
      '座位旁边请不要留空': '座位旁边请不要留空',
      '请输入取票手机号': '请输入取票手机号',
      '取消': '取消',
      '确定': '确定',
      '请填写正确手机号': '请填写正确手机号',
      '实名信息读取错误': '实名信息读取错误',
      '请先选座': '请先选座',
      '返回后，您选中的座位将不再保留': '返回后，您选中的座位将不再保留',
      '返回': '返回',
      '继续选座': '继续选座',
      '我知道了': '我知道了',
      '知道了': '知道了',
      '选座超时，请在10分钟内完成选座': '选座超时，请在10分钟内完成选座',
      '锁定座位失败，请重新选座': '锁定座位失败，请重新选座',
      '今天': '今天',
      '明天': '明天',
      '后天': '后天',
      '周一': '周一',
      '周二': '周二',
      '周三': '周三',
      '周四': '周四',
      '周五': '周五',
      '周六': '周六',
      '周日': '周日',
      '请填写姓名': '请填写姓名',
      '身份证': '身份证',
      '护照': '护照',
      '台胞证': '台胞证',
      '港澳台通行证': '港澳台通行证',
      '请选择证件类型': '请选择证件类型',
      '请填写证件号': '请填写证件号',
      '请填写正确的证件号码': '请填写正确的证件号码',
      '请填写11位手机号': '请填写11位手机号',
      '证件类型': '证件类型',
      '证件号码': '证件号码',
      '姓名': '姓名',
      '手机号': '手机号',
      '请输入证件号码': '请输入证件号码',
      '根据国家电影局疫情防控要求，购票需实名认证': '根据国家电影局疫情防控要求，购票需实名认证',
      '实名认证': '实名认证',
      '请输入姓名': '请输入姓名',
      '请输入手机号': '请输入手机号',
      '验证码发送成功': '验证码发送成功',
      '请核实订单信息确认无误后下单': '请核实订单信息确认无误后下单',
      '临近开场的场次出票时间较长且出票失败率高，请确认无误后下单': '临近开场的场次出票时间较长且出票失败率高，请确认无误后下单',
      '请填写验证码': '请填写验证码',
      '确认订单': '确认订单',
      '重新发送': '重新发送',
      '发送验证码': '发送验证码',
      '将在X分钟后开场': '将在X分钟后开场',
      '需支付': '需支付',
      '明细': '明细',
      '提交订单': '提交订单',
      '支付明细': '支付明细',
      '票品详情': '票品详情',
      '您选择的是X的场次': '您选择的是X的场次',
      '再看看': '再看看',
      '确认提交': '确认提交',
      '后开场': '后开场',
      '最新退款时间': '最新退款时间',
      '付款时间': '付款时间',
      '验证码不正确，请重新输入': '验证码不正确，请重新输入',
      '该手机号已被绑定': '该手机号已被绑定',
      '退票须知': '退票须知',
      '不支持退票': '不支持退票',
      '不支持改签': '不支持改签',
      '超出退票时间': '超出退票时间',
      '支持退票': '支持退票',
      '暂不支持改签服务': '暂不支持改签服务',
      '特别提醒': '特别提醒',
      '仅限整单退票，不支持分座位退票': '仅限整单退票，不支持分座位退票',
      '若支付金额小于退票服务费，不可退票': '若支付金额小于退票服务费，不可退票',
      '每人每月退票次数有限': '每人每月退票次数有限',
      '超时不可退': '超时不可退',
      '退票详情': '退票详情',
      '若支付金额小于退票手续费，不可退票': '若支付金额小于退票手续费，不可退票',
      '退票规则': '退票规则',
      '东福规则': '东福规则',
      '个别特殊场次根据影院要求可能不支持退票。具体以下单页面说明为准。': '个别特殊场次根据影院要求可能不支持退票。具体以下单页面说明为准。',
      '电影开场前一定时间内且用户未取票的情况下可支持退票，退票将可能产生额外服务费，具体退票规则及收费标准以下单页面说明为准。原订单实际支付金额扣除退票服务费后，剩余金额将在退票成功后7个工作日内原路退回。': '电影开场前一定时间内且用户未取票的情况下可支持退票，退票将可能产生额外服务费，具体退票规则及收费标准以下单页面说明为准。原订单实际支付金额扣除退票服务费后，剩余金额将在退票成功后7个工作日内原路退回。',
      '目前仅支持整笔订单退票，不支持单个座位退票。': '目前仅支持整笔订单退票，不支持单个座位退票。',
      '如发现作弊行为，东方福利网有权取消您的退票资格。': '如发现作弊行为，东方福利网有权取消您的退票资格。',
      '退票流程': '退票流程',
      '在“我的-我的订单-电影订单”中找到要退的电影票': '在“我的-我的订单-电影订单”中找到要退的电影票',
      '进入电影票详情，点击底部的“申请退票”按钮': '进入电影票详情，点击底部的“申请退票”按钮',
      '确认退款金额，点击“提交”退票申请按钮': '确认退款金额，点击“提交”退票申请按钮',
      '提交成功后，可在电影订单详情页查看退票进度': '提交成功后，可在电影订单详情页查看退票进度',
      '退款失败': '退款失败',
      '申请失败': '申请失败',
      '订单金额小于退票手续费，不可退票': '订单金额小于退票手续费，不可退票',
      '失败原因': '失败原因',
      '本月退票次数已用完，符合退票规则请联系在线客服咨询退票事宜': '本月退票次数已用完，符合退票规则请联系在线客服咨询退票事宜',
      '订单金额': '订单金额',
      '退票手续费': '退票手续费',
      '退款金额': '退款金额',
      '预计3个工作日内原路返回': '预计3个工作日内原路返回',
      '预计1-7个工作日，退款金额将原路退回到您的支付账户': '预计1-7个工作日，退款金额将原路退回到您的支付账户',
      '本次退款原因（必填）': '本次退款原因（必填）',
      '请放心选择，不影响退款申请哦': '请放心选择，不影响退款申请哦',
      '选好了': '选好了',
      '请选择退款原因': '请选择退款原因',
      '提交': '提交',
      '提交申请后不可撤销哦': '提交申请后不可撤销哦',
      '支付手续费并确认退票': '支付手续费并确认退票',
      '次卡兑换订单申请退票需单独支付手续费': '次卡兑换订单申请退票需单独支付手续费',
      '正在退订X张电影票': '正在退订X张电影票',
      '确认退票': '确认退票',
      '我知道了（XS后自动跳转）': '我知道了（XS后自动跳转）',
      '申请退款结果': '申请退款结果',
      '申请退款中': '申请退款中',
      '实退': '实退',
      '查看申请退款详情': '查看申请退款详情',
      '申请退款失败': '申请退款失败',
      '支付手续费原路退回您的付款账户': '支付手续费原路退回您的付款账户',
      '重新选座': '重新选座',
      '没有更多了': '没有更多了',
      '去支付': '去支付',
      '已有待支付订单，请先支付': '已有待支付订单，请先支付'
    }
  },
  drawer: {
    en: {
      '全部': 'All',
      '节日礼包': 'Festival gift bag',
      '蛋糕': 'Cake',
      '景点': 'Scenic spots',
      '玩乐': 'Recreation',
      '电子券': 'e-coupon',
      '影院': 'Cinema',
      '影片': 'Film',
      '场次': 'Session',
      '演出': 'Performance',
      '体检套餐': 'ME package',
      '体检机构': 'ME agency',
      '健康商城': 'Health mall',
      '运动健身': 'Fitness',
      '口腔健康': 'Mouth health',
      '线下商户': 'Offline merchant',
      '东福超市': 'DF market',
      '优选生活': 'Preferred life',
      '图书': 'Books',
      '京东优选': 'JD preference',
      '小米有品': 'MI selection',
      '网易严选': 'Lifease',
      '酒店': 'Hotel',
      '随心兑': 'Go-as-you-please exchange',
      '健康服务': 'Health service',
      '生日礼遇': 'Birthday party',
      '旅游玩乐': 'Tourism & entertainment',
      '热门演出': 'Popular performance',
      '热映观影': 'Hot film',
      '鲜花直送': 'Flower delivery',
      '企业团险': 'Enterprise insurance',
      '美团酒店': 'Meituan Hotel',
      '健康生活': 'Healthy life'
    },
    cn: {
      '全部': '全部',
      '节日礼包': '节日礼包',
      '蛋糕': '蛋糕',
      '景点': '景点',
      '玩乐': '玩乐',
      '电子券': '电子券',
      '影院': '影院',
      '影片': '影片',
      '场次': '场次',
      '演出': '演出',
      '体检套餐': '体检套餐',
      '体检机构': '体检机构',
      '健康商城': '健康商城',
      '运动健身': '运动健身',
      '口腔健康': '口腔健康',
      '线下商户': '线下商户',
      '东福超市': '东福超市',
      '优选生活': '优选生活',
      '图书': '图书',
      '京东优选': '京东优选',
      '小米有品': '小米有品',
      '网易严选': '网易严选',
      '酒店': '酒店',
      '随心兑': '随心兑',
      '健康服务': '健康服务',
      '生日礼遇': '生日礼遇',
      '旅游玩乐': '旅游玩乐',
      '热门演出': '热门演出',
      '热映观影': '热映观影',
      '鲜花直送': '鲜花直送',
      '企业团险': '企业团险',
      '美团酒店': '美团酒店',
      '健康生活': '健康生活'
    }
  }
};
